import reactComponentLoader from 'scripts/react-component-loader'

import { ContentList } from './'

reactComponentLoader(ContentList, '[data-content-list]')
